import { render, staticRenderFns } from "./PushNotificationMessage.vue?vue&type=template&id=1b8b8d6e&"
import script from "./PushNotificationMessage.vue?vue&type=script&lang=js&"
export * from "./PushNotificationMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports